import { useSelector, useDispatch } from 'react-redux'
import { Snackbar, Alert, AlertColor } from '@mui/material'
import { RootState, AppDispatch } from '../../store'
import { removeNotification } from '../../store/slices/uiSlice'

const ToastNotifications: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const notifications = useSelector((state: RootState) => state.ui.notifications)

  const handleClose = (id: string) => {
    dispatch(removeNotification(id))
  }

  return (
    <>
      {notifications.map((notification) => (
        <Snackbar
          key={notification.id}
          open={true}
          autoHideDuration={5000}
          onClose={() => handleClose(notification.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{ mb: notifications.indexOf(notification) * 6 }}
        >
          <Alert
            onClose={() => handleClose(notification.id)}
            severity={notification.type as AlertColor}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  )
}

export default ToastNotifications

